'use client'

import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

interface GroupOnlyProps {
  used?: string
}

const GroupOnly: React.FC<GroupOnlyProps> = ({ used }) => {
  return (
    <div className={clsx(styles.groupOnly, used)}>
      <i className={clsx('icon-font-icon_lock', styles.icon)} />
      <span>グループ限定</span>
    </div>
  )
}

export default GroupOnly
